/**
 * 项目相关请求接口
 */

import {baseUrl, pbrAxios} from '../../common/js/pbrAxios'



/**
 * 项目列表
 *
 * @param {Object}params - 请求参数
 * @returns {AxiosPromise<any>}
 */
const fetchProjectList = params => {
  return pbrAxios.post('/front/project/search', params)
}

/**
 *项目详情页——获取相关商机|资讯|风险信息接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 *    @param {String}params.id: 编号
 * @returns {AxiosPromise<any>}
 */
const fetchProjectReferensInfo = params => {
  return pbrAxios.post('/front/project/rinfos', params)
}

/**
 *项目详情页——获取基本|其他|历史|里程碑信息接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 *    @param {String}params.id: 项目编号
 * @returns {AxiosPromise<any>}
 */
const fetchProjectDetail = params => {
  return pbrAxios.post('/front/project/detail', params)
}

/**
 *项目详情页——获取国家相关法律|风险|报告|建议接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 *    @param {String}params.id: 项目编号
 * @returns {AxiosPromise<any>}
 */
const fetchProjectReferensOthers = params => {
  return pbrAxios.post('/front/project/cinfos', params)
}

/**
 *项目详情页——阅读次数加1接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.userid: 用户编号
 *    @param {String}params.id: 项目编号
 * @returns {AxiosPromise<any>}
 */
const addProjectReadTimes = params => {
  return pbrAxios.post('/front/project/read', params)
}

/**
 *项目列表页——获取检索条件接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 *    @param {String}params.module: sj：商机数据  fx：风险事件数据  xm：项目数据
 *    @param {Number}paramas.pagesize: 每页显示条数
 *    @param {Number}paramas.currentpage: 当前页
 * @returns {AxiosPromise<any>}
 */
const fetchProjectGCondition = params => {
  return pbrAxios.post('/front/project/gconditions', params)
}

/**
 * 发布项目——获取检索条件接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 * @returns {AxiosPromise<any>}
 */
const fetchMyprojectGConditions = params => {
  return pbrAxios.post('/front/myproject/gconditions', params)
}

/**
 * 发布项目——添加附件(弃用)
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 *    @param {String}params.module: sj：商机数据  fx：风险事件数据  xm：项目数据
 *    @param {Number}paramas.pagesize: 每页显示条数
 *    @param {Number}paramas.currentpage: 当前页
 * @returns {AxiosPromise<any>}
 */
const addMyprojectGAttachment = params => {
  return pbrAxios.post('/front/myproject/attachment', params)
}

/**
 * 项目列表页——发布项目——添加|修改
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 *    @param {String}params.title: sj：标题
 *    @param {String}paramas.summarize: 概述
 *    @param {String}paramas.countryId: 国家编号
 *    @param {String}paramas.countryName: 国家名称
 *    @param {String}paramas.address: 详细地址
 *    @param {String}paramas.companyName: 公司名称
 *    @param {String}paramas.industryId: 行业编号
 *    @param {String}paramas.industryName: 行业名称
 *    @param {String}paramas.typeId: 类型Id
 *    @param {String}paramas.typeName: 类型名称
 *    @param {String}paramas.stageId: 阶段编号
 *    @param {String}paramas.stageName: 阶段名称
 *    @param {String}paramas.planInvest: 投资金额
 *    @param {String}paramas.signAmount: 合同金额  eg：600000000
 *    @param {String}paramas.signAmountStr: 合同金额  eg：六千万
 *    @param {String}paramas.buildUnit: 承建单位
 *    @param {String}paramas.signDate:签订合同日期
 *    @param {String}paramas.planStartDate:计划开工日期
 *    @param {String}paramas.planEndDate:计划完工日期
 *    @param {String}paramas.realityStartDate:实际开工日期
 *    @param {String}paramas.realityEndDate:实际完工日期
 *    @param {String}paramas.planBuildCycle:计划建设周期
 *    @param {String}paramas.realityBuildCycle:实际建设周期
 *    @param {String}paramas.executeId:执行方式编号
 *    @param {String}paramas.executeName:执行方式名称
 *    @param {String}paramas.financingWayId:融资方式编号
 *    @param {String}paramas.financingWay:融资方式名称
 *    @param {String}paramas.financingStageId:融资阶段编号
 *    @param {String}paramas.financingStage:融资阶段名称
 *    @param {String}paramas.financingInfo:融资情况
 *    @param {String}paramas.contactName:联系人姓名
 *    @param {String}paramas.contactMobile:
 *    @param {String}paramas.contactPhone:
 *    @param {String}paramas.contactMailBox:
 *    @param {String}paramas.contactName2:
 *    @param {String}paramas.contactMobile2:
 *    @param {String}paramas.contactPhone2:
 *    @param {String}paramas.contactMailBox2:
 *    @param {String}paramas.accessoryPath:附件地址
 *    @param {String}paramas.id:我的项目编号（修改时使用）
 *    @param {String}paramas.userid:测试阶段必须有值
 * @returns {AxiosPromise<any>}
 */
const publishMyproject = params => {
  return pbrAxios.post('/front/myproject/save', params)
}

/**
 * 首页——我的项目|相关推荐|重点项目数据接口
 * @param params - 请求参数
 *    @param {String}params.hmodule: 检索模块标识 wp:重点项目  mp:我的项目  rp：推荐项目   默认重点项目
 *    @param {String}params.from: en:英文  cn：中文 其他：中文
 *    @param {Number}params.currentpage: 当前页  默认为1
 *    @param {Number}params.pagesize: 每页行数  默认20
 *    @param {String}params.userid: 用户编号 测试中在相关推荐和我的项目中需要传值
 * @returns {AxiosPromise<any>}
 */
const fetchProjectForIndex = params => {
  return pbrAxios.post('/front/project/psearch', params)
}

/**
 * 保存操作历史记录调用这个接口
 * @param params
 *  @param {String}params.subType:  riskEven  风险事件，riskArticle风险资讯 ， businessArticle  商机资讯，projectArticle 项目资讯
 * @returns {AxiosPromise<any>}
 */
const saveProjectSearchHistory = params => pbrAxios.post('/front/project/saveProjectSearchHistory', params)

/**
 * 项目详情页面-项目操作记录
 * @param params
 *  @param {String} params.projectId: 项目的id
 * @returns {AxiosPromise<any>}
 */
const fetchProjectHistoryOptionsList = params => pbrAxios.get('/front/enterprise/historyList', {params});

/**
 * 前端-项目导出excel列表
 * @param params
 *  @param {String} params.selections: 选中需要下载的ID, id之间以,逗号分隔 可选(为空则全部下载)
 *  @param {String} params.from: 语言
 * @returns {AxiosPromise<any>}
 */
const exportListExcel = params => pbrAxios.get('/front/project/exportListXls',{params})

/**
 * 前端-项目导出excel列表
 * @param params
 *  @param {String} params.id: 项目id
 *  @param {String} params.from: 语言
 * @returns {AxiosPromise<any>}
 */
const exportDetailWord = params => pbrAxios.get('/front/project/exportDetailWord',{params})
const exportProjectListExcelUrl = `/front/project/exportListXls`
const exportProjectDetailWordUrl = `/front/project/exportDetailWord`
export default {
  fetchProjectList,
  fetchProjectReferensInfo,
  fetchProjectDetail,
  fetchProjectReferensOthers,
  addProjectReadTimes,
  fetchProjectGCondition,
  fetchMyprojectGConditions,
  addMyprojectGAttachment,
  publishMyproject,
  fetchProjectForIndex,
  fetchProjectHistoryOptionsList,
  exportListExcel,
  exportDetailWord,
  exportProjectListExcelUrl,
  exportProjectDetailWordUrl,
  saveProjectSearchHistory
}
